import { Icon } from '@scuf/common';
import React, { useEffect } from 'react';
type AlertProps = {
    text: string;
    icon?: 'important' | 'help' | 'info' | 'check' | 'stop';
    className?: string;
    color?: 'orange' | 'red'
};
const Alert: React.FC<AlertProps> = ({
    text,
    icon = 'important',
    className,
    color = 'orange', // padrão
}) => {
    const alertClass =
        color === 'red' ? 'div-important-os' : 'div-alert-os';

    return (
        <div className={[alertClass, className].join(' ')}>
            <Icon root="common" name={`badge-${icon}`} color={color === 'red' ? '#ff0000' : '#f37021'} size="xlarge" />
            <h5>{text}</h5>
        </div>
    );
};



export default Alert;
